import { AtsJobPostingsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useJobPostings = () => {
  const { data, loading: loadingJobPostings } = useQuery(AtsJobPostingsDocument)

  const jobPostings = data?.ats.jobPostingsConnection.nodes || []

  return {
    jobPostings,
    loadingJobPostings,
  }
}
